<template>
  <div class="flex flex-col bg-gray-900 rounded-lg border border-gray-800 animate-pulse">
    <!-- Image skeleton -->
    <div class="relative w-full aspect-video bg-gray-800 rounded-t-lg" />

    <!-- Content skeleton -->
    <div class="flex flex-col gap-2 p-4 bg-gray-900 items-start">
      <!-- Title skeleton -->
      <div class="h-4 bg-gray-800 rounded w-3/4" />

      <!-- Tags skeleton -->
      <div class="flex flex-row gap-2">
        <div class="h-6 bg-gray-800 rounded-md w-16" />
        <div class="h-6 bg-gray-800 rounded-md w-12" />
      </div>
    </div>
  </div>
</template>

<script setup>
// No props needed for skeleton
</script>
